import ctl from '@netlify/classnames-template-literals';

const buttonStyle = ctl(`
  w-full 
  flex 
  items-center
  rounded-xl
  py-4 
  bg-bright-gray 
  hover:bg-silver-sand
`);

const contentAnimation = ctl(`
  overflow-hidden
  transition-all
  duration-500
`);

const buttonTitleStyle = ctl(`
  px-2 
  bg-blue-500 
  rounded-md 
  hover:bg-blue-600 
  transition  
`);

export default {
  buttonStyle,
  contentAnimation,
  buttonTitleStyle,
};
